import { EntityState } from '@reduxjs/toolkit';

import { ReferenceType } from '@/interfaces/grpc.interfaces';

import { ReferenceItemType } from '../types';
import { referencesSelectors } from '..';

/**
 * Расширяет переданные объекты типа ReferenceType их значениями из referencesState
 * @param referencesState слайс стейта, хранящий значения для объектов ReferenceType
 * @param references объекты, которые необходимо расширить дополнительными данными.
 */
const modifyReferences = (
  referencesState: EntityState<ReferenceItemType, ReferenceItemType['id']>,
  references: Array<ReferenceType>,
) => {
  for (const currentRef of references) {
    const referenceValue = referencesSelectors.selectById(referencesState, currentRef.id);

    if (!referenceValue?.data) {
      continue;
    }

    // displayName используется в проекте для отображения текстовой информации ReferenceType.
    // при этом позволяет сохранить оригинальные значения ReferenceType.
    const displayName = referenceValue.data.alternateName || referenceValue.data.name;

    Object.assign(currentRef, {
      ...referenceValue.data,
      displayName,
    });
  }
};

export default modifyReferences;
